export const LOGIN_SUCCESS_PAGE = '/dashboard';
export const LOGIN_FAILURE_PAGE = '/';
export const NOT_FOUND_PAGE = '/404';
